import Vuex from "vuex";
import Vue from "vue";
import { config } from "vuex-module-decorators";

Vue.use(Vuex);
export const store = new Vuex.Store({});

config.rawError = true;
